exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-type-form[data-v-2d6b5431]{z-index:30}", ""]);

// exports
